<div>
  <h1>{{'metering.title' | translate}}</h1>
</div>

<!-- Show contextual BannerMassages -->
<app-contextual-system-message-pane></app-contextual-system-message-pane>

<div [hidden]="!((customersLoaded$|async) && (meteringPointsLoaded$|async))" class="no-content" *ngIf="countSet && allMeteringPointsCount === 0">
  <app-no-content [displayText]="'meteringpoints.no_data'|translate"></app-no-content>
</div> 

<span  [ngClass]="{'sx-metering-point__tabs': (plannedDisruptions === 0 && unPlannedDisruptions === 0)}">
<mat-tab-group 
  id="group_meteringpoints" 
  *ngIf="hotMeteringPointsCount > 0 || coldMeteringPointsCount > 0" 
  mat-stretch-tabs="false"
  [selectedIndex]="selectedTabIndex" 
  (selectedTabChange)="fixTabs($event)" 
  appSelectedTab>
  <mat-tab label="{{'metering.tabs.title_meteringpoints'|translate}}" id="tab_meteringpoints">
    <div class="tab-content">
      <app-spinner [hidden]="(customersLoaded$|async) && (meteringPointsLoaded$|async)"></app-spinner>
      <div [hidden]="!((customersLoaded$|async) && (meteringPointsLoaded$|async))">
        <mat-tab-group class="magenta sx-metering-point__tabs-visible"
          mat-stretch-tabs="false"  
          (selectedIndexChange)="onTabIndexChange($event)"
          [selectedIndex]="selectTabIndex$|async" [ngClass]="{'sx-metering-point-single-metering-type': numberOfMeteringTypes === 1}">
          <mat-tab *ngIf="hotMeteringPointsCount > 0" id="tab_meteringpoints_hot" label="{{'metering.tabs.title_hot'|translate}}">
            <app-metering-points-pane [filterArea]="'Meteringpoints'" id="meteringpoints_pane_hot" [paneType]="'Hot'"
            [meteringPointSettings]="meteringPointSettings$|async"
            [userSettings]="userSettings$|async"
            [userInfo]="userInfo$ | async"
            (meteringPointSelected)="onMeteringPointSelected($event)"
            [selectedMeteringPointIds]="selectedHotMeteringPoints$|async"
            [virtualGroupActivated]="activatedHotVirtualGroup$|async"
            [customersWithMeteringPoints]="customersWithMeteringPoints$|async"
            [isMobile]="isMobile$|async"></app-metering-points-pane>
          </mat-tab>
          <mat-tab *ngIf="coldMeteringPointsCount > 0" id="tab_meteringpoints_cold" label="{{'metering.tabs.title_cold'|translate}}">
            <app-metering-points-pane [filterArea]="'Meteringpoints'" id="meteringpoints_pane_cold" [paneType]="'Cold'"
            [meteringPointSettings]="meteringPointSettings$|async"
            [userSettings]="userSettings$|async"
            [userInfo]="userInfo$ | async"
            (meteringPointSelected)="onMeteringPointSelected($event)"
            [selectedMeteringPointIds]="selectedColdMeteringPoints$|async"
            [virtualGroupActivated]="activatedColdVirtualGroup$|async"
            [customersWithMeteringPoints]="customersWithMeteringPoints$|async"
            [isMobile]="isMobile$|async"></app-metering-points-pane>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-tab>

  <mat-tab *ngIf="showMeteringPointGroups && (allMeteringPointsCount > 1)" id="tab_meteringpoint_groups" label="{{'metering.tabs.title_groups'|translate}}" >
    <app-spinner [hidden]="(meteringPointGroupsLoaded$|async)"></app-spinner>
    <div [hidden]="!(meteringPointGroupsLoaded$|async)">
      <mat-tab-group class="magenta sx-metering-point__tabs-visible sx-metering-point__scrollbar" mat-stretch-tabs="false" [ngClass]="{'sx-metering-point-single-metering-type': numberOfMeteringTypes === 1}">
        <mat-tab *ngIf="hotMeteringPointsCount > 0" id="tab_meteringpoint_groups_hot" label="{{'metering.tabs.title_hot' | translate}}">
        
          <app-metering-group-pane  [filterArea]="'Meteringpoints'" id="meteringpointgroups_pane_hot" [userInfo]="userInfo$ | async" [paneType]="'Hot'" [meteringPointGroups]="meteringPointGroups$ | async"
            [userSettings]="userSettings$ | async"></app-metering-group-pane>
        </mat-tab>
        <mat-tab  *ngIf="coldMeteringPointsCount > 0" id="tab_meteringpoint_groups_cold" label="{{'metering.tabs.title_cold' | translate}}">
          <app-metering-group-pane  [filterArea]="'Meteringpoints'"id="meteringpointgroups_pane_cold" [userInfo]="userInfo$ | async" [paneType]="'Cold'" [meteringPointGroups]="meteringPointGroups$ | async"
            [userSettings]="userSettings$ | async"></app-metering-group-pane>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="tab-content">
    </div>
  </mat-tab>
  <mat-tab id="myid" class="sx-disruptions-tab" label="{{'metering.tabs.title_disturbance'|translate}}"> 
    <app-spinner [hidden]="(customersLoaded$|async) && (meteringPointsLoaded$|async) && (customersWithDisruptions$|async).length !== 0"></app-spinner>
    <app-metering-points-disruptions-pane (meteringPointSelected)="onMeteringPointSelected($event)" [customersWithDisruptions]="customersWithDisruptions$|async"></app-metering-points-disruptions-pane>
    <div class="tab-content">
    </div>
  </mat-tab>
 
  
</mat-tab-group>
</span>
